import { Component, ViewChild, TemplateRef, ElementRef, Input, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EditorComponent } from '../editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { firstValueFrom, forkJoin } from 'rxjs';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

@Component({
  selector: 'app-audit-report-finding-detail',
  templateUrl: './audit-report-finding-detail.component.html',
  styleUrls: ['./audit-report-finding-detail.component.scss']
})
export class AuditReportFindingDetailComponent implements OnInit, OnChanges {
  baList: any = [];
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  selectedGroupValue: any = null;
  isProcessing: boolean = false;
  refreshbreadcrumb: boolean = true;
  showReportFlagValue: any;
  showCharts: boolean = false;
  groupValueDropdown: any = [];
  selectedTaskTypeValue: any = [];
  dropDownForChangeType: any = [];
  changeTypeDropdown: any = [];
  specificIntervalVal: boolean = false;
  showBAChart: boolean = false;
  selectedIntervalValue: any = null;
  showSpecificInterval: boolean = false;
  chartOptionsForBa: any;
  selectedDateRangeValue: any = null;
  fromDate: any;
  toDate: any;
  showTables: boolean = false;
  intervalValueDropdown: any = [];
  groupdataList: any = [];
  dateCustomClasses: DatepickerDateCustomClasses[];
  dateRangeValueDropdown: any = [];
  FollowupdateRangeValueDropdown: any = [];
  dropDownForInterval: any = [];
  dropDownForDateRange: any = [];
  dropDownForFollowupDateRange: any = [];
  selectedDepartmentValue: any = [];
  searchByDepartmentCode: any = null;
  departmentCodeDropdown: any = [];
  dropDownForDepartmentCode: any = [];
  annualRefNo: any;
  subGroupName: any;
  findingTableReportDataList: any = [];
  followupTableReportDataList: any = [];
  recommendationTableReportDataList: any = [];
  showNoRecordFoundRecomandation: boolean = false;
  findingList: any = [];
  followupList: any = [];
  severityList: any = [];
  chartOptionsForFinding: any;
  chartOptionsForSeverity: any;
  chartOptionsForFollowup: any;
  chartOptionsForFindingZoom: any;
  chartOptionsForSeverityZoom: any;
  titleName = '';
  clickedType = "";
  clickedVal = "";
  activityId: any;
  clickedStageStatusVal = "";
  isDropdownDisabled: boolean = true;

  departmentSearchText: string = '';

  columnsListForExcel: any;
  fieldLabelsListForExcel: any;
  invisibleColumnForExcel: any;
  dynamicGridName: any;
  dynamicGridViewName: any;
  snackbarRef: any;
  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  findingRepVwDataForGrid: any = [];
  findingRepVwDataForGridDropdown: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};

  pagedItems6: any[];
  pagedItems7: any[];
  showMore: boolean = false;

  toggleMore() {
    this.showMore = !this.showMore;
  }
  @ViewChild(BreadcrumbComponent) breadcrumbComponent!: BreadcrumbComponent;
  constructor(public dialog: MatDialog, public appService: AppService, public message: messageService, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public route: ActivatedRoute, public service: messageService, public qmsservice: qmsService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute, public paginationService: PaginationService) {
    this.appService.isProcessingRep = false;
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reportPopupForZoom', { static: true }) reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;
  reportPopupConfig = {
    width: '120%',
    height: '680px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };

  selectBoxeForGroupValue() {

    this.groupValueDropdown = [];

    for (const group of this.groupdataList) {
      this.groupValueDropdown = this.groupValueDropdown.concat({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }
    this.isProcessing = false;
  }
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  selectBoxeForchangeType() {
    this.changeTypeDropdown = [];
    for (const group of this.dropDownForChangeType) {
      this.changeTypeDropdown = this.changeTypeDropdown.concat({
        valueExp: group.codelistCode,
        displayExp: group.codelistName
      });
    }
  }
  selectBoxForFollowupDateRange() {
    this.FollowupdateRangeValueDropdown = [];

    for (const group of this.dropDownForFollowupDateRange) {
      this.FollowupdateRangeValueDropdown = this.FollowupdateRangeValueDropdown.concat({
        valueExp: group.codelistCode,
        displayExp: group.codelistName
      });
    }
  }
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    for (const group of this.dropDownForDateRange) {
      this.dateRangeValueDropdown = this.dateRangeValueDropdown.concat({
        valueExp: group.codelistCode,
        displayExp: group.codelistName
      });
    }

  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    for (const group of this.dropDownForInterval) {
      this.intervalValueDropdown = this.intervalValueDropdown.concat({
        valueExp: group.codelistCode,
        displayExp: group.codelistName
      });
    }
  }

  selectBoxeForDepartmentCode() {
    for (const item of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }
  handleDropDownValidation(fieldId: string, selectedItems: [] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'pdf-select-all');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;
    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }
  specificIntervalFun(e: any) {
    if (e.checked) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
      if (this.qmsservice.reportFor == 'Followup') {
        this.selectedDateRangeValue = 'DUE_DATE';
      } else {
        this.selectedDateRangeValue = 'RESPONSE_DUE_DATE';
      }
      this.fromDate = null;
      this.toDate = null;
      this.selectedIntervalValue = 'MONTH';
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
    }
  }

  resetFunction() {
    this.specificIntervalVal = false;
    this.fromDate = null;
    this.toDate = null;
    this.selectedDateRangeValue = null;
    this.searchByDepartmentCode = null;
    this.showCharts = false;
    this.showTables = false;
    this.activityId = null;
    this.annualRefNo = null;
  }

  genFindnigReport() {
    this.findingList = [];
    this.followupList = [];
    this.severityList = [];
    this.chartOptionsForFinding = null;
    this.chartOptionsForSeverity = null;
    this.chartOptionsForFollowup = null;
    if (this.qmsservice.reportFor == 'Finding') {
      if (!this.selectedGroupValue) {
        const field = document.getElementById('groupNameAlert') as HTMLInputElement;
        field.style.color = 'red';
      } else if (this.specificIntervalVal && this.selectedDateRangeValue == null) {
        alert('Please select date range');
      } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else {
        let data = {
          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: "AU",
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: null,
          status: null,
          deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
          annualRefNo: this.annualRefNo ?? null,
          subGroupName: this.subGroupName ?? null,
          no: this.activityId,

        }


        const promises = [
          firstValueFrom(this.appService.getFindingBaReportVal(data)),
          firstValueFrom(this.appService.getAuFindingReportVal(data)),
          firstValueFrom(this.appService.getAuFindingSeverityReportVal(data)),

        ]; // Convert each observable to a promise
        // Use Promise.all to wait for all promises to resolve
        Promise.all(promises)
          .then(([baList, findingList, severityList]) => {
            this.baList = baList;
            this.findingList = findingList;
            this.severityList = severityList;

            this.createChart();
            setTimeout(() => {
              this.isProcessing = false;

            }, 8000);
          },
            error => {
              console.error('Error in forkJoinObservable:', error);
              setTimeout(() => {
                this.isProcessing = false;
              }, 8000);
            });
      }
    } else if (this.qmsservice.reportFor == 'Followup') {
      if (!this.selectedGroupValue) {
        const field = document.getElementById('groupNameAlert2') as HTMLInputElement;
        field.style.color = 'red';
      } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else {
        let data = {
          groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
          module: "AU",
          dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: null,
          status: null,
          deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
          annualRefNo: this.annualRefNo ?? null,
          subGroupName: this.subGroupName ?? null,
          no: this.activityId,
        }

        const promises = [
          firstValueFrom(this.appService.getAuFollowupReportVal(data))
        ];
        Promise.all(promises)
          .then(([followupList]) => {
            this.followupList = followupList;
            this.createChart();
            setTimeout(() => {
              this.isProcessing = false;
            }, 8000);
          },
            error => {
              console.error('Error in forkJoinObservable:', error);
              setTimeout(() => {
                this.isProcessing = false;
              }, 8000);
            });
      }
    } else if (this.qmsservice.reportFor == 'Recommendation') {
      this.tableDataList("recommandation", "");
    }
  }

  moveTop() {
    this.showCharts = false;
    setTimeout(() => {
      window.scrollTo({ top: 220, behavior: 'smooth' });
      this.showCharts = true;
    }, 1000);
  }
  clickedChartVal: any;
  chartDoubleClick(val: any) {
    this.createChartZoom(val);
    this.clickedChartVal = val;
    if (val == 1) {
      this.titleName = "Finding Status";
      this.tableDataListForAll("finding");
      this.clickedType = "finding";
      this.clickedVal = "finding";
      this.clickedStageStatusVal = "";
    }
    if (val == 2) {
      this.titleName = "Finding Severity"
      this.tableDataListForAll("severity");
      this.clickedType = "severity";
      this.clickedVal = "severity";
      this.clickedStageStatusVal = "";
    }
    this.visibleReportPopupForZoom = this.dialog.open(this.reportPopupForZoom, this.reportPopupConfig);

  }

  createChartZoom(val: any) {
    if (val == 1) {
      this.chartOptionsForFindingZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          // itemWidth: 150,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Finding Status (${this.getTotalCountFinding()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{status}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForFinding(),
          click: this.handleFindingChartClick.bind(this) // Reference the click event handler for the entire pie chart
        }]
      };

    }

    if (val == 2) {
      this.chartOptionsForSeverityZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          // itemWidth: 150,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Finding severity (${this.getTotalCountSeverity()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{severity}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForSeverity(),
          click: this.handleSeverityChartClick.bind(this) // Reference the click event handler for the entire pie chart
        }]
      };
    }

  }

  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#05004E',
    '#839EFF',
    '#00A6A9',
    '#0081A5'
  ];

  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];
    }
  }
  createChart() {
    this.chartOptionsForBa = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: `Bussiness Area (${this.getTotalCountBa()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.baList.length > 15 ? 20 : 38,
      dataPointMinWidth: this.baList.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.baList.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.baList.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.baList.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getBaYAxisInterval(),
        labelFormatter: (e: any) => {
          return this.baList.length === 1 ? "" : e.value;
        }
      },


      axisX: this.baList.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.baList.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        color: "#05004E",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        dataPoints: this.getDataPointsForBa(),
        click: this.handleBaChartClick.bind(this)
      }]
    };
    this.chartOptionsForFinding = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Finding Status (${this.getTotalCountFinding()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForFinding(),
        click: this.handleFindingChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };
    this.chartOptionsForFollowup = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Followup Status(${this.getTotalCountFollowup()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForFollowup(),
        click: this.handleFollowupChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };
    this.chartOptionsForSeverity = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Finding severity (${this.getTotalCountSeverity()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{severity}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForSeverity(),
        click: this.handleSeverityChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };


    this.moveTop();
  }
  getDataPointsForFinding() {
    const dataPoints = this.findingList.map((finding: { count: any; status: any; }, index: any) => ({
      y: finding.count,
      indexLabel: `${finding.status}:${finding.count}`,
      color: this.colorMethod(finding.status, index)
    }));
    return dataPoints;
  }
  getDataPointsForFollowup() {
    const dataPoints = this.followupList.map((followup: { count: any; status: any; }, index: any) => ({
      y: followup.count,
      indexLabel: `${followup.status}:${followup.count}`,
      color: this.colorMethod(followup.status, index)
    }));
    return dataPoints;
  }

  getDataPointsForSeverity() {
    const dataPoints = this.severityList.map((severity: { count: any; severity: any; }, index: any) => ({
      y: severity.count,
      indexLabel: `${severity.severity}:${severity.count}`,
      color: this.colorMethod(severity.severity, index)
    }));
    return dataPoints;
  }
  handleFindingChartClick(e: any): void {
    this.titleName = "Finding Status"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("finding", this.findingList[e.dataPointIndex].status);
    this.clickedType = "Finding";
    this.clickedVal = this.findingList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }
  getTotalCountFinding() {
    return this.findingList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleFollowupChartClick(e: any): void {
    this.titleName = "Followup Status"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("followup", this.followupList[e.dataPointIndex].status);
    this.clickedType = "Followup";
    this.clickedVal = this.followupList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }
  getTotalCountFollowup() {
    return this.followupList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleSeverityChartClick(e: any): void {
    this.titleName = "Finding Severity"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("severity", this.severityList[e.dataPointIndex].severity);
    this.clickedType = "severity";
    this.clickedVal = this.severityList[e.dataPointIndex].severity;
    this.clickedStageStatusVal = "";
  }
  getTotalCountSeverity() {
    return this.severityList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  whereValsForExcel: any;
  tableDataList(type: any, valueOfWhere: any) {
    let whereVals = "";
    if (type == "finding") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE STATUS='" + valueOfWhere + "'";
      this.dynamicGridName = "FINDINGS_REPORT";
      this.dynamicGridViewName = "QMS_AU_FINDINGS_INTERVAL_REP_VW";
      if (this.activityId) {


        whereVals += " AND AU_ID='" + this.activityId + "'";


      }
      if (this.searchByDepartmentCode) {
        whereVals += " AND AUDIT_DEPARTMENT='" + this.searchByDepartmentCode + "'";
      }
      if (this.annualRefNo) {
        whereVals += " AND ANNUAL_REF_NO='" + this.annualRefNo + "'";
      }
      if (this.subGroupName) {
        whereVals += " AND SUB_GROUP_NAME='" + this.subGroupName + "'";
      }
      this.getcallMethod(whereVals);
    } else if (type == "ba") {
      this.showReportFlagValue = 1;
      this.showReportFlagValue = 1;
      whereVals = " WHERE INSTR(',' || CORE_BUSINESS_AREA_NAME || ',', ',"
        + valueOfWhere
        + ",') > 0 "

      //this.baWhereVals = " WHERE ORG_ID=?1 AND CORE_BUSINESS_AREA_NAME LIKE '%" + valueOfWhere + "%'";
      //WHERE INSTR(',' || CORE_BUSINESS_AREA_NAME || ',', ',M01,') > 0AND ORG_ID = ?1;
      this.dynamicGridName = "FINDINGS_REPORT";
      this.dynamicGridViewName = "QMS_AU_FINDINGS_INTERVAL_REP_VW";
      if (this.activityId) {

        whereVals += " AND AU_ID='" + this.activityId + "'";


      }
      if (this.searchByDepartmentCode) {
        whereVals += " AND AUDIT_DEPARTMENT='" + this.searchByDepartmentCode + "'";
      }
      if (this.annualRefNo) {
        whereVals += " AND ANNUAL_REF_NO='" + this.annualRefNo + "'";
      }
      if (this.subGroupName) {
        whereVals += " AND SUB_GROUP_NAME='" + this.subGroupName + "'";
      }
      this.getcallMethod(whereVals);
    } else if (type == "severity") {
      this.showReportFlagValue = 1;
      if (valueOfWhere) {
        whereVals = " WHERE SEVERITY='" + valueOfWhere + "'";
      } else {
        whereVals = " WHERE SEVERITY IS NULL OR SEVERITY = ''";
      }
      this.dynamicGridName = "FINDINGS_REPORT";
      this.dynamicGridViewName = "QMS_AU_FINDINGS_INTERVAL_REP_VW";
      if (this.activityId) {


        whereVals += " AND AU_ID='" + this.activityId + "'";


      }
      if (this.searchByDepartmentCode) {
        whereVals += " AND AUDIT_DEPARTMENT='" + this.searchByDepartmentCode + "'";
      }
      if (this.annualRefNo) {
        whereVals += " AND ANNUAL_REF_NO='" + this.annualRefNo + "'";
      }
      if (this.subGroupName) {
        whereVals += " AND SUB_GROUP_NAME='" + this.subGroupName + "'";
      }
      this.getcallMethod(whereVals);
    } else if (type == "followup") {
      this.showReportFlagValue = 4;
      whereVals = " WHERE STATUS='" + valueOfWhere + "'";
      this.dynamicGridName = "FOLLOWUP_REPORT";
      this.dynamicGridViewName = "QMS_AU_FOLLOWUPS_INTERVAL_REP_VW";
      if (this.activityId) {
        whereVals += " AND AU_ID='" + this.activityId + "'";
        ;
      }
      if (this.searchByDepartmentCode) {
        whereVals += " AND AUDIT_DEPARTMENT='" + this.searchByDepartmentCode + "'";
      }
      if (this.annualRefNo) {
        whereVals += " AND ANNUAL_REF_NO='" + this.annualRefNo + "'";
      }
      if (this.subGroupName) {
        whereVals += " AND SUB_GROUP_NAME='" + this.subGroupName + "'";
      }
      this.getcallMethod(whereVals);
    } else if (type == "recommandation") {
      whereVals += " Where ORG_ID=?1 ";
      this.showReportFlagValue = 5;
      this.dynamicGridName = "RECOMMENDATION_REPORT";
      this.dynamicGridViewName = "QMS_AU_RECOMMENDATION_INTERVAL_REP_VW";
      if (this.activityId) {


        whereVals += " AND AU_ID='" + this.activityId + "'";


      }
      if (this.searchByDepartmentCode) {
        whereVals += " AND AUDIT_DEPARTMENT='" + this.searchByDepartmentCode + "'";
      }
      if (this.annualRefNo) {
        whereVals += " AND ANNUAL_REF_NO='" + this.annualRefNo + "'";
      }
      if (this.subGroupName) {
        whereVals += " AND SUB_GROUP_NAME='" + this.subGroupName + "'";
      }
      this.getcallMethod(whereVals);
    }
    this.whereValsForExcel = whereVals;

  }
  tableDataListForAll(type: any) {
    let whereVals = "";
    if (type == "finding") {
      this.showReportFlagValue = 1;
      this.dynamicGridName = "FINDINGS_REPORT";
      this.dynamicGridViewName = "QMS_AU_FINDINGS_INTERVAL_REP_VW";
      if (this.activityId) {
        if (type == "recommandation") {
          whereVals += " Where AU_ID='" + this.activityId + "'";
        } else {
          whereVals += " WHERE AU_ID='" + this.activityId + "'";
        }
      }
      if (this.searchByDepartmentCode) {
        whereVals += " AND AUDIT_DEPARTMENT='" + this.searchByDepartmentCode + "'";
      }
      if (this.annualRefNo) {
        whereVals += " AND ANNUAL_REF_NO='" + this.annualRefNo + "'";
      }
      if (this.subGroupName) {
        whereVals += " AND SUB_GROUP_NAME='" + this.subGroupName + "'";
      }
      this.getcallMethod(whereVals);
    } else if (type == "severity") {
      this.showReportFlagValue = 1;
      this.dynamicGridName = "FINDINGS_REPORT";
      this.dynamicGridViewName = "QMS_AU_FINDINGS_INTERVAL_REP_VW";
      if (this.activityId) {

        if (type == "recommandation") {
          whereVals += " Where AU_ID='" + this.activityId + "'";

        } else {
          whereVals += " Where AU_ID='" + this.activityId + "'";

        }
      }
      if (this.searchByDepartmentCode) {
        whereVals += " AND AUDIT_DEPARTMENT='" + this.searchByDepartmentCode + "'";
      }
      if (this.annualRefNo) {
        whereVals += " AND ANNUAL_REF_NO='" + this.annualRefNo + "'";
      }
      if (this.subGroupName) {
        whereVals += " AND SUB_GROUP_NAME='" + this.subGroupName + "'";
      }
      this.getcallMethod(whereVals);
    }
    this.whereValsForExcel = whereVals;
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.findingRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.findingRepVwDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  viewDescription(Description: string) {

    this.htmlContent = Description;
    this.editorComponent.openEditor(this.htmlContent, 'Description');
    this.isProcessing = false;
  }
  viewReferenceDetails(ReferenceDetails: string) {

    this.htmlContent = ReferenceDetails;
    this.editorComponent.openEditor(this.htmlContent, 'ReferenceDetails');
    this.isProcessing = false;
  }
  viewReference(Reference: string) {

    this.htmlContent = Reference;
    this.editorComponent.openEditor(this.htmlContent, 'Reference');
    this.isProcessing = false;
  }
  viewFindingShortDescription(findingShortDescription: string) {

    this.htmlContent = findingShortDescription;
    this.editorComponent.openEditor(this.htmlContent, 'Finding Short Description');
    this.isProcessing = false;
  }
  viewComments(comments: string) {

    this.htmlContent = comments;
    this.editorComponent.openEditor(this.htmlContent, 'Comments');
    this.isProcessing = false;
  }
  viewResponseReviewComments(responseReviewComments: string) {

    this.htmlContent = responseReviewComments;
    this.editorComponent.openEditor(this.htmlContent, 'Response Review Comments');
    this.isProcessing = false;
  }
  viewImplementationReviewerComments(implementationReviewerComments: string) {

    this.htmlContent = implementationReviewerComments;
    this.editorComponent.openEditor(this.htmlContent, 'Implementation Reviewer Comments');
    this.isProcessing = false;
  }
  viewResponceVerificationComments(responceVerificationComments: string) {

    this.htmlContent = responceVerificationComments;
    this.editorComponent.openEditor(this.htmlContent, 'Responce Verification Comments');
    this.isProcessing = false;
  }
  viewImplemetationVerificationComments(implemetationVerificationComments: string) {

    this.htmlContent = implemetationVerificationComments;
    this.editorComponent.openEditor(this.htmlContent, 'Implemetation Verification Comments');
    this.isProcessing = false;
  }

  getClobData1(list: any, colunName: any) {

    let modifiedColumnName = colunName;
    switch (colunName) {
      case "FINDING":
        modifiedColumnName = "Finding";
        break;
      case "AUDITOR_COMMENTS":
        modifiedColumnName = "Auditor Comments";
        break;
      case "DELIVERABLES":
        modifiedColumnName = "Deliverables";
        break;
      case "ROOT_CAUSE_ANALYSIS":
        modifiedColumnName = "Root Cause Analysis";
        break;
      case "CORRECTIVE_ACTION":
        modifiedColumnName = "Corrective Action";
        break;
      case "PREVENTIVE_ACTION":
        modifiedColumnName = "Preventive Action";
        break;
      case "IMMEDIATE_CORRECTION":
        modifiedColumnName = "Immediate Correction";
        break;
      case "CLOSURE_COMMENTS":
        modifiedColumnName = "Closure Comments";
        break;
      default:
        break;
    }

    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName,
    };
    let data2 = {
      groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
      module: "AU",
      dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
      stageName: null,
      status: null,
      deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
      annualRefNo: this.annualRefNo ?? null,
      subGroupName: this.subGroupName ?? null,
      wherVal: "",
      reModule: "qmsClob"
    }
    let data3 = { ...docObj, ...data2 };
    this.htmlContent = "";
    this.appService.getClobToViewAudit(data3).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, modifiedColumnName);
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });

    this.isProcessing = false;
  }
  getcallMethod(whereVals: any) {
    this.findingRepVwDataForGrid = [];
    const data = {

      groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
      gridName: this.dynamicGridName,
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        this.columnsListForExcel = response.columnsList ?? "";
        this.fieldLabelsListForExcel = response.fieldLabelsList ?? "";
        this.invisibleColumnForExcel = response.invisibleColumn == null ? "" : response.invisibleColumn + ",ASSIGNED_TO_USER";

        this.makeStickyColumns = response.fixedFieldCnt;
        this.columnList = this.fieldLabelsListForExcel;
        const data1: any = {

          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn == null ? "" : response.invisibleColumn + ",ASSIGNED_TO_USER",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields + ",ACTUAL_CLOSED_DATE,START_DATE,END_DATE,DUE_DATE,EXPECTED_CLOSURE_DATE,EXPECTED_PA_CLOSURE_DATE,EXPECTED_CA_CLOSURE_DATE",
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        let data2;
        if (this.qmsservice.reportFor == 'Finding') {
          data2 = {
            groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
            module: "AU",
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
            annualRefNo: this.annualRefNo ?? null,
            subGroupName: this.subGroupName ?? null,
            wherVal: whereVals ? whereVals + " AND ORG_ID=?1" : " Where ORG_ID=?1",
            reModule: "qms"
          }
        } else if (this.qmsservice.reportFor == 'Followup') {
          data2 = {
            groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
            module: "AU",
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
            wherVal: whereVals + " AND ORG_ID=?1 ",
            reModule: "qms"
          }
        } else if (this.qmsservice.reportFor == 'Recommendation') {
          data2 = {
            groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
            module: "AU",
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
            wherVal: whereVals || " Where ORG_ID=?1",
            reModule: "qms"
          }
        }
        this.reportObj = { ...data1, ...data, ...data2 };
        this.appService.getDynamicGridData(this.reportObj).subscribe({
          next: (response1: any) => {
            this.findingRepVwDataForGrid = response1;
            if (this.qmsservice.reportFor == 'Recommendation') {
              this.showTables = true;
              this.showNoRecordFoundRecomandation = this.findingRepVwDataForGrid.length === 0;
            }
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              this.columnLists.invisibleColumnarray.forEach((invisibleColumn: any) => {
                if (this.columnLists.columnsListarray[y] === invisibleColumn) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              });
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const finding of this.findingRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    finding[dataType.columnName] = finding[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.findingRepVwDataForGrid;
            this.collectionSize = this.findingRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.findingRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  error = '';
  pagedItems: any[];
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.findingRepVwDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.findingRepVwDataForGrid
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }
  cancelReportPopupForZoomFunction() {
    this.visibleReportPopupForZoom.close();
  }
  //Excell & PDF
  popupDataTitle: any = {};
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {

    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  isSaveReport: boolean = false;

  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      let invisibleList = "";
      if (this.showReportFlagValue == 1) {
        tname = "QMS_AU_FINDINGS_INTERVAL_REP_VW";
        colList = this.columnsListForExcel;
        fieldList = this.fieldLabelsListForExcel;
        invisibleList = this.invisibleColumnForExcel;
      } else if (this.showReportFlagValue == 4) {
        tname = "QMS_AU_FOLLOWUPS_INTERVAL_REP_VW";
        colList = this.columnsListForExcel;
        fieldList = this.fieldLabelsListForExcel;
        invisibleList = this.invisibleColumnForExcel;
      } else if (this.showReportFlagValue == 5) {
        tname = "QMS_AU_RECOMMENDATION_INTERVAL_REP_VW";
        colList = this.columnsListForExcel;
        fieldList = this.fieldLabelsListForExcel;
        invisibleList = this.invisibleColumnForExcel;
      }
      const data = {

        groupId: this.qmsservice.selectedGroup
      }
      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: invisibleList,
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: null,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        reModule: "qms",
        footer: this.selectedReportFooter,
        logoId: this.selectedReportLogoValue ?? 0,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? "CR_Report",
        currentStatus: "NA",
        groupName: this.qmsservice.activity.groupName + "",
      }
      let data2 = {

        groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
        module: this.qmsservice.moduleName,
        dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
        fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
        toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
        intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
        stageName: null,
        status: null,
        wherVal: this.whereValsForExcel
      }
      this.reportObj = { ...data1, ...data, ...data2 };
      debugger;
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
        .format(new Date(timestamp))
        .replaceAll(',', '')
        .replaceAll(' ', '_');

      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      let fileName = '';
      if (this.showReportFlagValue === 1 || this.showReportFlagValue === 4) {
        fileName = `${this.clickedType}_${this.clickedVal}_${formattedDate}.${fileType}`;
      } else if (this.showReportFlagValue === 5) {
        fileName = `Recommendation_${formattedDate}.${fileType}`;
      }
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: "Report", columns: [],
          "informationTab": {
            "Report Name": `${this.clickedType}_${this.clickedVal}` + "Report",
            "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, fileName + ".xlsx");
      } else if (this.showReportFlagValue == 1 || this.showReportFlagValue == 4) {
        const pdfData = {
          ...this.reportObj, title: `${this.clickedType}_${this.clickedVal}` + " Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName + ".pdf");
      } else if (this.showReportFlagValue == 5) {
        const pdfData = {
          ...this.reportObj, title: "Recommendation Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName + ".pdf");
      }

    }
  }
  openReportPopup(item: any) {
    if (this.showReportFlagValue == 1 || this.showReportFlagValue == 4 || this.showReportFlagValue == 5) {
      this.excelPdf.dropDown = this.columnLists.fieldColumnarray.map((column: any) => ({ valueExp: column.fieldColumnarray, displayExp: column.fieldColumnarray }));
    } else {
      this.excelPdf.dropDown = this.columnList.split(',');
    }
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.pdfColumnSelection = false;
    this.isSaveReport = false;
  }

  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  setPage6(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.followupTableReportDataList.length, page, this.perPage, targetpage);
    if (this.followupTableReportDataList.length > 0) {
      this.pagedItems6 = this.followupTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall6(value: number) {
    this.perPage = value;
    this.setPage6(this.pager.currentPage, 0);
  }
  setPage7(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.recommendationTableReportDataList.length, page, this.perPage, targetpage);
    if (this.recommendationTableReportDataList.length > 0) {
      this.pagedItems7 = this.recommendationTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall7(value: number) {
    this.perPage = value;
    this.setPage7(this.pager.currentPage, 0);
  }
  //more activity
  moreActivityReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/MoreActivityReportDetailsComponent/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }
  auditFindingReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
      this.refreshbreadcrumb = false;
      this.ngOnChanges();
      this.router.navigate(['/dashboard/AuditReportFindingDetailComponent/', this.qmsservice.moduleName]);
      this.resetFunction();
      this.genFindnigReport();
    }
  }
  findingDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/findingDueDate/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }
  followupDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/followupDueDate/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }

  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.findingTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.findingTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems6 = this.followupTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems6 = this.followupTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }


  applyFilter2(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems7 = this.recommendationTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems7 = this.recommendationTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  ngOnChanges() {
    this.message.breadcrumbData.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
    this.message.breadcrumbData.thirdLevel = 'Report';
    this.message.breadcrumbData.fourthLevel = this.qmsservice.reportFor;
    if (this.breadcrumbComponent) {
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      this.breadcrumbComponent.thirdLevel = 'Report';
      this.breadcrumbComponent.fourthLevel = this.qmsservice.reportFor;
    }
    this.refreshbreadcrumb = true;
  }
  groupSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  onGroupValueSelect1st(item: any) {
    this.handleDropDownValidation('groupNameAlert', item);
  }
  onAnnualRefNoSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.annualRefNo = null;
    }
  }
  onuniqueSubGroupNameSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.subGroupName = null;
    }
  }
  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedTaskTypeValue = [];
      this.appService.getQmsGroupDetailsByModule(this.selectedGroupValue ? this.selectedGroupValue : null, this.qmsservice.moduleName).subscribe((data: any) => {
        this.qmsservice.selectedGroupDetailData = data;
      });
      this.handleDropDownValidation('groupNameAlert', this.selectedGroupValue)
    }
  }
  @ViewChild('pdfColumnVal') pdfColumnVal: MatSelect;
  pdfColumnSelection = false;
  // toggleAllSelection1() {
  //   if (this.pdfColumnSelection) this.pdfColumnVal.options.forEach((item: MatOption) => item.select());
  //   else {
  //     this.pdfColumnVal.options.forEach((item: MatOption) => item.deselect())
  //     this.selectedColumns = [];
  //   }
  //   setTimeout(() => {
  //     this.handleDropDownValidation('initial-complaint-category-validation', this.selectedColumns)
  //     this.convertArrayToString(this.selectedColumns);
  //   });
  // }
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  @ViewChild('pdf') pdf: MatSelect;

  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfColumnSelection) {
        this.pdf.options.forEach((item: MatOption) => item.select());
      } else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });

    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) {
          this.maxCountReached = true;
        } else {
          this.maxCountReached = false;
        }
        this.convertArrayToString(this.selectedColumns);
        this.pdfColumnSelection = this.selectedColumns.length === this.excelPdf.dropDown.length;
      });
    }

  }

  onPDFSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.pdfColumnSelection = this.excelPdf.dropDown.length == this.selectedColumns.length;
        this.convertArrayToString(this.selectedColumns);
      })
    }
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const reportImage of this.organizationReportImageDetails) {

              if (reportImage.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: reportImage.reportImageId,
                  displayExp: reportImage.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const reportImage of this.organizationReportImageDetails) {
          if (reportImage.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: reportImage.reportImageId,
              displayExp: reportImage.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const reportLogo of this.reportLogoDropdown) {
          if (reportLogo.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = reportLogo.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {

    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter


              = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsservice.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.selectedGroupValue = this.qmsservice.SelectedGroupNameAndValue[0].valueExp;
      this.refreshbreadcrumb = false;
      this.ngOnChanges();
      this.onGroupValueSelect1st({ valueExp: this.qmsservice.SelectedGroupNameAndValue[0].valueExp, displayExp: this.qmsservice.SelectedGroupNameAndValue[0].displayExp })
      forkJoin([
        this.appService.getCodeListsByGroup('AUDIT_FOLLOWUP_REPORT_DATERANGE'),
        this.appService.getCodeListsByGroup('AUDIT_FINDING_REPORT_DATERANGE'),
        this.appService.getCodeListsByGroup('REPORT_INTERVAL'),
        this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT'),
        this.appService.getQmsReportUsers(this.qmsservice.moduleName),
      ]).subscribe(([auditFollowupDateRange, AudtFindingDateRangeData, DropDownForIntervalData, auditDepartment, groupdataList]) => {
        this.dropDownForFollowupDateRange = auditFollowupDateRange;
        this.selectBoxForFollowupDateRange();
        this.dropDownForDateRange = AudtFindingDateRangeData;
        this.selectBoxForDateRange();
        this.dropDownForInterval = DropDownForIntervalData;
        this.selectBoxForInterval();
        this.dropDownForDepartmentCode = auditDepartment;
        this.selectBoxeForDepartmentCode();
        this.groupdataList = groupdataList;
        this.selectBoxeForGroupValue();
        if (this.selectedGroupValue) {
          this.genFindnigReport();
        }
      });
    });



    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.selectedGroupValue).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();
    this.getcallMethodNgOnInit();
  }
  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.dynamicGridName, this.dynamicGridViewName, this.qmsservice.moduleName, this.selectedGroupValue);
  }
  onChildValueEmitted() {
    this.visibleReportPopup.close();
    this.genFindnigReport();
  };

  uniqueAnnualRefNo: any;
  uniqueSubGroupName: any;
  getcallMethodNgOnInit() {
    let whereVals: any;
    this.findingRepVwDataForGrid = [];
    if (this.qmsservice.reportFor == 'Finding') {
      this.dynamicGridName = "FINDINGS_REPORT";
    } else if (this.qmsservice.reportFor == "followup") {
      this.dynamicGridName = "FOLLOWUP_REPORT";
    } else if (this.qmsservice.reportFor == "recommandation") {
      this.dynamicGridName = "RECOMMENDATION_REPORT";
    }
    const data = {

      groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
      gridName: this.dynamicGridName,
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        this.columnsListForExcel = response.columnsList ?? "";
        this.fieldLabelsListForExcel = response.fieldLabelsList ?? "";
        this.invisibleColumnForExcel = response.invisibleColumn == null ? "" : response.invisibleColumn + ",ASSIGNED_TO_USER";
        this.makeStickyColumns = response.fixedFieldCnt;
        this.columnList = this.fieldLabelsListForExcel;
        const data1: any = {

          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn == null ? "" : response.invisibleColumn + ",ASSIGNED_TO_USER",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields + ",ACTUAL_CLOSED_DATE,START_DATE,END_DATE,DUE_DATE,EXPECTED_CLOSURE_DATE,EXPECTED_PA_CLOSURE_DATE,EXPECTED_CA_CLOSURE_DATE",
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        let data2;
        if (this.qmsservice.reportFor == 'Finding') {
          data2 = {
            groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
            module: "AU",
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
            annualRefNo: this.annualRefNo ?? null,
            subGroupName: this.subGroupName ?? null,
            wherVal: whereVals ? whereVals + " AND ORG_ID=?1" : " Where ORG_ID=?1",
            reModule: "qms"
          }
        } else if (this.qmsservice.reportFor == 'Followup') {
          data2 = {
            groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
            module: "AU",
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
            wherVal: whereVals + " AND ORG_ID=?1 ",
            reModule: "qms"
          }
        } else if (this.qmsservice.reportFor == 'Recommendation') {
          data2 = {
            groupId: this.selectedGroupValue ? this.selectedGroupValue.toString() : null,
            module: "AU",
            dateRangeAt: this.selectedDateRangeValue ? this.selectedDateRangeValue : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
            wherVal: whereVals ?? " Where ORG_ID=?1",
            reModule: "qms"
          }
        }
        this.reportObj = { ...data1, ...data, ...data2 };
        this.appService.getDynamicGridData(this.reportObj).subscribe({
          next: (response1: any) => {
            this.findingRepVwDataForGridDropdown = response1;
            this.uniqueAnnualRefNo = Array.from(
              new Set(
                this.findingRepVwDataForGridDropdown
                  .map((data: { ANNUAL_REF_NO: any }) => data.ANNUAL_REF_NO)
                  .filter((value: any) => value !== null && value !== undefined && value !== '')
              )
            );

            this.uniqueSubGroupName = Array.from(
              new Set(
                this.findingRepVwDataForGridDropdown
                  .map((data: { SUB_GROUP_NAME: any }) => data.SUB_GROUP_NAME)
                  .filter((value: any) => value !== null && value !== undefined && value !== '')
              )
            );
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  getDataPointsForBa() {
    const dataPoints = this.baList.map((ba: { cnt: any; baValue: any; }) => ({
      label: `${ba.baValue}`,
      y: ba.cnt
    }));
    return dataPoints;
  }
  handleBaChartClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Business Area Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("ba", this.baList[e.dataPointIndex].baValue);
    this.clickedType = "Business Area";
    this.clickedVal = this.baList[e.dataPointIndex].baValue;
    this.clickedStageStatusVal = "";
  }

  generateGroupSummary(val: any, ty: any): any[] {
    if (!val?.length) {
      return [];
    }
    const dataSummary: any = {};
    if (ty == 'ba') {
      val.forEach((item: any) => {
        const baValue = item.baValue?.trim();
        const count = Number(item.cnt) || 0;
        const key = baValue;
        if (!dataSummary[key]) {
          dataSummary[key] = {
            BusinessArea: baValue,
            Count: 0
          };
        }
        dataSummary[key].Count += count;
      });
    }
    return Object.values(dataSummary);
  }

  getTotalCountBa() {
    return this.baList.reduce((total: number, item: { cnt: number }) => total + item.cnt, 0);
  }

  getBaYAxisInterval() {
    const maxValue = Math.max(...this.baList.map((item: { cnt: number }) => item.cnt));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };
}
